import type { LayoutBlock } from '@web-studio/shared-schemas';
import { chefStoryBlockDefault } from '../blocks/chefStory';
import { dynamicMenuFlowDefault } from '../blocks/dynamicMenu';
import { footerStandardDefault } from '../blocks/footer';
import { heroEditorialDefault } from '../blocks/hero';
import { menuGrid3ColumnDefault } from '../blocks/menu';
import { navigationHeaderDefault } from '../blocks/navigation';

/** Restaurant / recommended — full implemented stack for demos. */
export const restaurantRecommendedPage: LayoutBlock[] = [
  { ...navigationHeaderDefault, displayOrder: 0 },
  { ...heroEditorialDefault, displayOrder: 1 },
  { ...menuGrid3ColumnDefault, displayOrder: 2 },
  { ...dynamicMenuFlowDefault, displayOrder: 3 },
  { ...chefStoryBlockDefault, displayOrder: 4 },
  { ...footerStandardDefault, displayOrder: 5 },
];
